module.exports = __webpack_public_path__ + "static/media/create-success.f9c57db5.png";